import Vue from 'vue'
import 'babel-polyfill'
import inject from './plugins/inject'
import App from './App'
import router from './plugins/router'
// import axios from 'axios'
import store from './vuex/index'
import './directive'
import './mixin'
import './assets/font/iconfont.css'
// import './plugins/flexible'
import echarts from 'echarts'
// import MonitorSdk from './monitor-sdk-esmodule'
// console.log(MonitorSdk)
/* eslint-disable no-new */
// new MonitorSdk({
//   axios: axios,
//   reportUrl: window.ENV.VUE_APP_MONITOR_REPORT_URL// 如果没整改用env.js的 则用变量process.env.VUE_APP_MONITOR_REPORT_URL
//   // isStopMonitor: process.env.NODE_ENV === 'development' // 注意这里使用process.env
// })
// import './mock' // simulation data
// window.gitVersion = process.env.gitVersion
// // 建议 统一放到public/static/js文件夹下
// if (process.env.NODE_ENV === 'production') {
//   // 开发、测试环境(发送到我的账号测试流程)
//   const dom = document.createElement('script')
//   dom.innerHTML = `var _hmt = _hmt || [];_hmt.push(['_setAutoPageview', false]);
//   (function() {
//     var hm = document.createElement("script");
//     hm.src = '${window.SRC.hmSrc}';
//     var s = document.getElementsByTagName("script")[0];
//     s.parentNode.insertBefore(hm, s);
//   })();`
//   document.querySelector('head').append(dom)
// }

Vue.use(inject)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

window.vueApp = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

if (process.env.NODE_ENV !== 'production') {
  const themeContext = require.context('./style/themes', true, /index\.less$/)
  themeContext.keys().forEach(theme => {
    require('./style/themes' + theme.substring(1))
  })
}



// WEBPACK FOOTER //
// ./src/main.js